<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .main {
    width: 100%;
    height: 100%;

    .swiper-wrap {
      position: relative;
      top: -438px;

      .list-item {
        margin: 2.5px;
        display: flex;

        .item {
          background: #0B2574;
          width: 25%;
        }

        .itemtransparent {
          background: transparent;
          width: 25%;
          height: 50px;
          line-height: 35px;
        }
      }
    }

    .list-item {
      margin: 5px;
      height: 50px;
      line-height: 50px;
      display: flex;

      .item {
        background: #0B2574;
        width: 25%;
      }

      .itemtransparent {
        background: transparent;
        width: 25%;
      }
      .right 
      {
        margin-right:10px;
      }
      
    }

    .list-item1 {
      color: #00FEFB;
      height: 50px;
      // background: url('../../../../../assets/img/helpPoor/top1.png') no-repeat;
      background-size: 100% 100%;
      line-height: 50px;
      display: flex;

      .item {
        width: 25%;
      }

      .right 
      {
        margin-right:10px;
      }
    }
  }
}
</style>

<template>
  <!-- <boxWrap :name="name"> -->
  <div class="table">
    <div class="main">
      <div class="list-item list-item1">
        <div class="item">待迁移数据</div>
        <div class="item right">已迁移数据</div>
        <div class="item" style="width:50%">迁移数据记录</div>
        <!-- <div class="item">耗时/ms</div> -->
      </div>
      <div class="list-item">
        <div class="item">蔬菜溯源数据</div>
        <div class="item right">小麦溯源数据</div>
        <div class="item">数据名称</div>
        <div class="item">耗时/ms</div>
      </div>
      <div class="list-item">
        <div class="item">生鲜乳检测数据</div>
        <div class="item right">甜菜溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">水果溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">生猪溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">牛肉溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">羊肉溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">禽肉溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">牛奶溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="list-item">
        <div class="item"></div>
        <div class="item right">蘑菇溯源数据</div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="tableData.length != 0">
        <swiper-slide v-for="(item, index) in tableData" :key="index" class="list-item">
          <div class="itemtransparent "></div>
          <div class="itemtransparent "></div>
          <div class="itemtransparent">{{ item.regionName }}</div>
          <div class="itemtransparent">{{ item.amount }}</div>
          <!-- <div class="item">{{item.listed}}</div> -->
        </swiper-slide>
      </swiper>
    </div>
  </div>
  <!-- </boxWrap> -->
</template>

<script>
import boxWrap from '../common/boxWrap';
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: ['povertyAlleviaList'],
  data() {
    return {
      name: '',
      tableData: [],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    // boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {
    // this.tableData = this.povertyAlleviaList
    this.tableData = [
      {
        poor: "",
        familyPopulation: "4",
        regionName: "扎兰屯沙果溯源数据",
        amount: "800"
      },
      {
        poor: "",
        familyPopulation: "4",
        regionName: "呼伦贝尔草原白蘑溯源数据",
        amount: "90"
      },
      {
        poor: "",
        familyPopulation: "4",
        regionName: "凉城白瓜子溯源数据",
        amount: "60"
      },
      {
        poor: "",
        familyPopulation: "4",
        regionName: "丰镇月饼安全检测数据",
        amount: "20"
      },
      {
        poor: "",
        familyPopulation: "4",
        regionName: "阿尔巴斯白绒山羊溯源数据",
        amount: "900"
      },
      {
        poor: "",
        familyPopulation: "4",
        regionName: "托县辣椒检测数据",
        amount: "600"
      },
      {
        poor: "",
        familyPopulation: "4",
        regionName: " 正蓝旗乌日穆产品检测数据",
        amount: "30"
      }
    ]
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?6af8d3c2